




















import { computed, defineComponent } from '@vue/composition-api';
import TipBox from '@/components/common/tip-box/index.vue';

const name = 'ttam-creative-tracking-pixel-tips';

export default defineComponent({
  name,
  components: {
    TipBox,
  },

  props: {
    pcmDropTipVisible: { type: Boolean, default: false },
    domainNotMatchTipVisible: { type: Boolean, default: false },
  },

  setup() {
    const aadvid = computed(() => {
      const searchObj = window.location.search
        .replace('?', '')
        .split('&')
        .reduce((obj, item) => {
          const [key, value] = item.split('=');
          obj[key] = value;
          return obj;
        }, {} as Record<string, string>);

      return searchObj.aadvid ?? '';
    });

    return {
      aadvid,
    };
  },
});
